import React, { useEffect, useRef, useState } from 'react';
import './AdRail.css';

const AdRail = ({ position }) => {
  const adRef = useRef(null);
  const pushed = useRef(false);
  // 'loading' stays invisible (but keeps its layout space) until we know
  // whether the slot actually filled, so reloads never flash a blank box.
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (adRef.current && !pushed.current) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        pushed.current = true;
      } catch (e) {
        setStatus('unfilled');
      }
    }

    const el = adRef.current;
    if (!el) return;

    const checkStatus = () => {
      const adStatus = el.getAttribute('data-ad-status');
      if (adStatus === 'unfilled') setStatus('unfilled');
      else if (adStatus === 'filled') setStatus('filled');
    };

    const observer = new MutationObserver(checkStatus);
    observer.observe(el, { attributes: true, attributeFilter: ['data-ad-status'] });

    // Ad blockers or slow networks may never set data-ad-status at all.
    const fallback = setTimeout(() => {
      if (!el.getAttribute('data-ad-status')) setStatus('unfilled');
    }, 3000);

    return () => {
      observer.disconnect();
      clearTimeout(fallback);
    };
  }, []);

  if (status === 'unfilled') return null;

  return (
    <aside
      className={`ad-rail ad-rail--${position}`}
      aria-label="Advertisement"
      style={status === 'loading' ? { visibility: 'hidden' } : undefined}
    >
      <div className="ad-rail-inner">
        <ins
          className="adsbygoogle"
          style={{ display: 'block', width: '300px', height: '250px' }}
          data-ad-client="ca-pub-4746911113417000"
          data-ad-slot="auto"
          data-ad-format="rectangle"
          ref={adRef}
        />
      </div>
    </aside>
  );
};

export default AdRail;
